<script setup>
    import { ref, computed, watch } from 'vue'
    import { isNullOrEmpty, isEmail, isPhoneNumber, isValidatePassword, toCamelCase, toDateFormat, formatCurrency } from '@/composables/utils';


    const props = defineProps({
        show: Boolean,
        type: {
            type: String,
            required: true,
            validator: (value) => ['subscription', 'topup'].includes(value)
        },
        data: {
            type: Number,
            name: String,
            price: Number

        }
    })

    const emit = defineEmits(['update:show', 'submit'])

    const loading = ref(false);
    const model = ref({
        Amount: null,
        Discount: 0,
        TaxRate: 0,
        Tax: 0,
        Total: 0,
        PromotionStr:null
    });

    const form = ref({
        Type: null,
        PromoCode: null,
        IsPreview:true
    });

    const promoCodeloading = ref(false)

    const taxRate = ref(0.13)

  
    async function proceedToPayment() {
        if (props.type == 'subscription') {
            handleSubscriptionCheckout(false);
        } else if (props.type == 'topup') {
            handleTopUpCheckout(false);
        }
    }

    function handleClose() {
        emit('update:show', false)
        form.value.PromoCode = ''
    }

    function handleSubscriptionCheckout(preview=true) {

        form.value.IsPreview = preview;
      

        loading.value = true;
        window.$http.request("post", '/api/app/billing/subscriptioncheckout', form.value).then((res) => {
            if (res?.Type == 200) {
                if (preview) {
                    model.value = res.Data;
                } else {
                    window.location.href = res.Data.Url;
                }
               
            }
            loading.value = false;
        });
       
    }

    function handleTopUpCheckout(preview = true) {

        form.value.IsPreview = preview;

        loading.value = true;
        window.$http.request("post", '/api/app/billing/topupcheckout', form.value).then((res) => {
            if (res?.Type == 200) {
                if (preview) {
                    model.value = res.Data;
                } else {
                    window.location.href = res.Data.Url;
                }

            }
            loading.value = false;
        });

    }

    watch(() => props.show, () => {
        if (props.show) {
            form.value.Type = props.data.type;
            if (props.type == 'subscription') {
                handleSubscriptionCheckout();
            } else if (props.type == 'topup') {
               handleTopUpCheckout();
            }
        }

    }, { immediate: true });
</script>

<template>
    <NModal :show="props.show" preset="card" title="Checkout" style="width: 90%; max-width: 500px"
            :bordered="false" @update:show="(val) => emit('update:show', val)" @after-leave="handleClose" :mask-closable="false">
        
        <div class="flex flex-col gap-4" >
           
         
            <div class="bg-gray-50 dark:bg-gray-800 p-3 rounded text-center" >
                <n-spin size="large" v-if="model.Amount==null"  />
                <template v-else>
                    <div class="flex justify-between">
                        <NText>{{model.Name}}</NText>
                        <NText>{{ formatCurrency(model.Amount) }}</NText>
                    </div>

                    <div v-if="model.Discount>0" class="flex justify-between mt-2">
                        <NText type="success">Discount</NText>
                        <NText type="success">
                            -{{ formatCurrency(model.Discount) }}
                            <span>({{ model.PromotionStr }})</span>
                        </NText>
                    </div>
                    <div v-if="model.CreditUsed>0" class="flex justify-between mt-2">
                        <NText type="success">Use Credit</NText>
                        <NText type="success">
                            -{{ formatCurrency(model.CreditUsed) }}
                        </NText>
                    </div>

                    <div v-if="model.Tax>0" class="flex justify-between mt-2">
                        <NText>Tax ({{ (model.TaxRate * 100).toFixed(0) }}%)</NText>
                        <NText>{{ formatCurrency(model.Tax) }}</NText>
                    </div>

                    <NDivider class="my-2" />

                    <div class="flex justify-between font-semibold">
                        <NText>Total</NText>
                        <NH2 class="m-0">{{ formatCurrency(model.Total) }}</NH2>
                    </div>


                    <div class="flex gap-2 justify-end mt-4" v-if="model.IsPromotionAllowed">
                        <NInput v-model:value="form.PromoCode" class="!w-[200px]" placeholder="Promo Code" :disabled="promoCodeloading" @keydown.enter="applyPromoCode" />
                        <NButton type="primary" ghost :loading="promoCodeloading" @click="handleSubscriptionCheckout(true)" :disabled="form.PromoCode?.length==0">Apply</NButton>

                    </div>
                    <div v-if="model.PromotionStr!=null && form.PromoCode==model.PromoCode && model.Discount == 0" class="pt-1 text-red-500">
                        {{model.PromotionStr}}
                    </div>
                </template>
               
            </div>

         

            <NButton type="primary" size="large" block :loading="loading" :disabled="model.Amount==null" @click="proceedToPayment">Proceed to Payment</NButton>

            <div class="text-center">
                <NText depth="3" class="text-xs">
                    You'll be redirected to Stripe's secure checkout page
                </NText>
            </div>
        </div>
    </NModal>
</template>